import { colors, border } from "utils/constants";

export const customersBarChartStyles = {
  mb: "24px",
  pr: { md: "32px !important", lg: "32px !important" },
};

export const statsCardHeading = { color: colors?.black?.light, mb: "4px" };

export const cardStats = { color: colors?.black?.dark };

export const statsCardGrid = { p: "20px !important", borderRight: border };

export const statsLastCardGrid = { ...statsCardGrid, borderRight: "none" };

export const sectionDividerPadding = { pr: "36px !important" };

export const tableRowBackground = { background: "#EEE" };

export const tableCellPadding = { padding: "16px 8px" };

export const chartDimensions = { width: "100%", height: "300px" };

export const tableStatsStyle = { color: "#212121", lineHeight: "12px" };
